module.exports = __webpack_public_path__ + "img/bottom_banner2.15746691.webp";